var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperAndPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.158,
    height: 16.938,
    viewBox: "0 0 20.158 16.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1199",
    "data-name": "Groupe 1199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_612",
    "data-name": "Trac\\xE9 612",
    d: "M-574.452,1257.858l-1.437,1.962-2.759,3.766-1.743,2.379-.113.75.727-.289,4.352-5.939,1.6-2.185c-.06-.051-.147-.121-.247-.2a2.11,2.11,0,0,0-.381-.246Zm-2.174,1.421,1.6-2.191.117-.16.2-.025a.832.832,0,0,1,.1-.006,2.035,2.035,0,0,1,1.1.487,1.754,1.754,0,0,1,.674.885h0a.642.642,0,0,1,.006.072v.146l-.089.123c-.285.391-.98,1.341-1.77,2.419l-4.429,6.044-.077.1-.124.049-1.59.631-.74.293.119-.786.249-1.646.017-.11.068-.092,1.811-2.471,2.759-3.766Zm2.886-.892s0,0,0,0l.014.114Z",
    transform: "translate(592.986 -1255.064)",
    fill: "#19c3b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_613",
    "data-name": "Trac\\xE9 613",
    d: "M-673.345,1241.9h12.6a1.117,1.117,0,0,1,.728.26.827.827,0,0,1,.3.626v4.07l-.916,1.076v-5.145a.092.092,0,0,0-.034-.069.124.124,0,0,0-.08-.029h-12.6a.124.124,0,0,0-.081.029.091.091,0,0,0-.034.069v15.165a.092.092,0,0,0,.034.069.123.123,0,0,0,.081.029h10.23l2.483-2.129v-3.141c.195-.1.317-.162.318-.163l.129-.1.469-.551v4.282l-.136.117-2.753,2.361-.322.115h-10.417a1.117,1.117,0,0,1-.728-.26.827.827,0,0,1-.3-.626v-15.165a.827.827,0,0,1,.3-.626A1.118,1.118,0,0,1-673.345,1241.9Z",
    transform: "translate(674.376 -1241.902)",
    fill: "#19c3b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAndPen);
export default __webpack_public_path__ + "static/media/paper-and-pen.21c381958aeae01cc7bd06f0a6b68d7d.svg";
export { ForwardRef as ReactComponent };